import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import { ChatListItemFragmentDoc } from './ChatsNavSection.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateDirectMessageMutationVariables = Types.Exact<{
  input: Types.CreateDirectMessageInput;
}>;


export type CreateDirectMessageMutation = { __typename?: 'Mutation', createDirectMessage: { __typename?: 'ChatMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, chat?: { __typename?: 'Chat', id: string, chatType: Types.ChatType, viewerIsAdminOrChatOwner: boolean, membersCanEditTitle: boolean, membersCanEditMembers: boolean, unreadCount: number, displayTitle: string, viewerArchivedAt?: string | null, latestMessageText?: string | null, latestMessageHasAttachments: boolean, title?: { __typename?: 'TranslationSet', en: string } | null, userSelectionSet: { __typename?: 'UserSelectionSet', id: string, userSelections: Array<{ __typename?: 'UserSelection', id: number, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number }> }> }, members: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> } | null } };


export const CreateDirectMessageDocument = gql`
    mutation CreateDirectMessage($input: CreateDirectMessageInput!) {
  createDirectMessage(input: $input) {
    success
    error {
      code
    }
    chat {
      ...ChatListItem
    }
  }
}
    ${ChatListItemFragmentDoc}`;
export type CreateDirectMessageMutationFn = Apollo.MutationFunction<CreateDirectMessageMutation, CreateDirectMessageMutationVariables>;

/**
 * __useCreateDirectMessageMutation__
 *
 * To run a mutation, you first call `useCreateDirectMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDirectMessageMutation, { data, loading, error }] = useCreateDirectMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDirectMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateDirectMessageMutation, CreateDirectMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDirectMessageMutation, CreateDirectMessageMutationVariables>(CreateDirectMessageDocument, options);
      }
export type CreateDirectMessageMutationHookResult = ReturnType<typeof useCreateDirectMessageMutation>;
export type CreateDirectMessageMutationResult = Apollo.MutationResult<CreateDirectMessageMutation>;
export type CreateDirectMessageMutationOptions = Apollo.BaseMutationOptions<CreateDirectMessageMutation, CreateDirectMessageMutationVariables>;